import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import { hexToRgba } from 'builder/styles/colors'
import { ButtonV2 } from 'builder/components/Button'
import Icon24 from 'builder/components/Icon'
import Typography, { FontWeights } from 'builder/styles/typography'

export const Container = styled.div`
  display: flex;
  position: relative;
`

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
`

export const Button = styled(ButtonV2)`
  height: 36px;
`

export const ActionMenuContainer = styled.div<{ isVisible: boolean }>`
  display: flex;
  flex-direction: column;
  padding: ${Spacing['4XS']} ${Spacing['3XS']};
  position: absolute;
  background-color: ${Colors.White};
  border-radius: ${Spacing['2XS']};
  z-index: 1000;
  top: 40px;
  right: 0;
  width: 152px;
  box-shadow: 0px 2px 4px -1px rgba(15, 56, 113, 0.08), 0px 8px 20px -4px rgba(15, 56, 113, 0.12);
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
  transform: ${({ isVisible }) => (isVisible ? 'translateY(0)' : 'translateY(-10px)')};
  transition: opacity 0.3s ease, transform 0.3s ease, visibility 0.3s ease;
  pointer-events: ${({ isVisible }) => (isVisible ? 'auto' : 'none')};
`

export const ActionMenuItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: ${Spacing['2XS']};
  padding: ${Spacing['2XS']};
  color: ${Colors.Neutral100};
  border-radius: ${Spacing['3XS']};
  cursor: pointer;

  &:hover {
    color: ${Colors.Blue50};
    background-color: ${Colors.Blue10};

    svg {
      color: ${Colors.Blue50};
    }
  }
`

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: ${Colors.Neutral50};
`

export const IconChevronDown = styled(Icon24.ChevronDownV2)`
  width: 24px;
  height: 24px;
  transition: transform 0.3s ease;
`

export const ActionButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
`

export const SelectedActionWrapper = styled.div`
  position: relative;
  width: 74px;
`

export const SelectedAction = styled.div<{
  isDownloadMenuOpen: boolean
  isPreviewLayout?: boolean
}>`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  padding: 6px ${Spacing['4XS']} 6px ${Spacing['2XS']};
  height: 36px;
  color: ${({ isDownloadMenuOpen, isPreviewLayout }) =>
    isDownloadMenuOpen ? Colors.Blue50 : isPreviewLayout ? Colors.White : Colors.Neutral90};
  border: 1px solid
    ${({ isDownloadMenuOpen }) => (isDownloadMenuOpen ? Colors.Blue50 : Colors.Neutral20)};
  background-color: ${({ isDownloadMenuOpen }) =>
    isDownloadMenuOpen ? Colors.Blue10 : 'transparent'};
  border-radius: ${Spacing['3XS']} 0 0 ${Spacing['3XS']};
  border-right: 0;
  cursor: pointer;
  transition: color 0.3s ease, background-color 0.3s ease, border 0.3s ease;
  ${Typography.Caption};
  ${FontWeights.Medium};

  svg {
    color: ${({ isDownloadMenuOpen, isPreviewLayout }) =>
      isDownloadMenuOpen ? Colors.Blue50 : isPreviewLayout ? Colors.Neutral50 : Colors.Neutral70};
    transition: color 0.3s ease;
  }

  &:hover {
    color: ${Colors.Blue50};
    border: 1px solid ${Colors.Blue50};
    border-right: 0;
    background-color: ${Colors.Blue10};

    svg {
      color: ${Colors.Blue50};
    }
  }
`

export const ActionButton = styled(ButtonV2)`
  height: 36px;
  border-radius: 0 ${Spacing['3XS']} ${Spacing['3XS']} 0;
`

export const Separator = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${Colors.Neutral15};
  margin: 1px 0;
`

export const IconUpNDown = styled(Icon24.UpNDown)`
  color: ${Colors.Neutral50};
  transition: color 0.3s ease;
`

export const MobileOverlay = styled.div<{ isVisible: boolean }>`
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 32px 20px;
  background-color: ${hexToRgba(Colors.Neutral100, 0.8)};
  opacity: ${props => (props.isVisible ? 1 : 0)};
  pointer-events: ${props => (props.isVisible ? 'auto' : 'none')};
  transition: opacity 0.2s ease;
`

export const MobileCancelButton = styled.div<{ isVisible: boolean }>`
  padding: 12px;
  margin-top: 16px;
  border-radius: 6px;
  background-color: ${Colors.White};
  color: ${Colors.Blue50};
  text-align: center;
  font-weight: 600;
  cursor: pointer;

  transition-property: opacity, transform;
  transition-timing-function: ease-out;
  transition-delay: 0.05s;
  transition-duration: 0.3s;
  opacity: ${props => (props.isVisible ? 1 : 0)};
  transform: translateY(${props => (props.isVisible ? 0 : 28)}px) translateZ(0);
`

export const MobileOptionsContainer = styled.div<{ isVisible: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${Colors.White};
  border-radius: 6px;
  transition-property: opacity, transform;
  transition-timing-function: ease-out;
  transition-delay: 0.05s;
  transition-duration: 0.3s;
  opacity: ${props => (props.isVisible ? 1 : 0)};
  transform: translateY(${props => (props.isVisible ? 0 : 28)}px) translateZ(0);
`

export const MobileOption = styled.div`
  display: flex;
  align-items: center;
  padding: 16px;
  gap: 8px;
  cursor: pointer;
  color: ${Colors.Neutral90};
  ${Typography.Body}
`

export const ShareOption = styled.div<{ isVisible: boolean }>`
  display: flex;
  align-items: center;
  padding: 16px;
  gap: 8px;
  cursor: pointer;
  color: ${Colors.Neutral90};
  ${Typography.Body}
  background-color: ${Colors.White};
  border-radius: 6px;
  margin-top: 16px;
  transition-property: opacity, transform;
  transition-timing-function: ease-out;
  transition-delay: 0.05s;
  transition-duration: 0.3s;
  opacity: ${props => (props.isVisible ? 1 : 0)};
  transform: translateY(${props => (props.isVisible ? 0 : 28)}px) translateZ(0);
`
